import { motion } from "framer-motion";
import Question from "./Question";
import "./SubscriptionFaq.scss";
import { Trans, useTranslation } from "react-i18next";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring" as const,
      stiffness: 300,
      damping: 25,
      mass: 0.8,
    },
  },
};

const SubscriptionFaq: React.FC = () => {
  const { t } = useTranslation();
  const faqList = t("pages.Pricing.faq", { returnObjects: true }) as Array<{
    question: string;
    answer: string;
  }>;
  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.9 }}
          transition={{
            duration: 0.5,
            type: "tween" as const,
            stiffness: 300,
            damping: 25,
            mass: 0.8,
          }}
          className="header-faq"
        >
          <h2 className="title-faq">FAQ</h2>
        </motion.div>

        <motion.div
          className="questions-container"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {faqList.map((faq, index) => (
            <Question
              key={index}
              number={index + 1}
              title={faq.question}
              defaultOpen={index === 0}
              variants={itemVariants}
            >
              <p className="answer">
                <Trans
                  i18nKey={faq.answer}
                  components={{ br: <br />, strong: <strong />, i: <i /> }}
                />
              </p>
            </Question>
          ))}
        </motion.div>
        {/* 
        <motion.p
          className="footer"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.8 }}
          transition={{
            delay: 0.8,
            type: "spring",
            stiffness: 200,
            damping: 20,
          }}
        >
          Still have questions? <span>Talk to us!</span>
        </motion.p> */}
      </div>
    </section>
  );
};

export default SubscriptionFaq;
